/*
 * Copyright (c) 2020. American Express Company
 */

import { LocalDate } from '@js-joda/core';

export class RecurringExpenseModel {
    id?: number;
    name: string;
    monthlyAmount: number;
    categories: string;
    groupUid?: string;
    startDate: LocalDate;
    endDate: LocalDate;
}
